export const decryptData = (data) => {
    const Cryptr = require('cryptr');
    const cryptr = new Cryptr(process.env.REACT_APP_PROVIDERS_SALT);
    return cryptr.decrypt(data)
}

export const encryptData = (data) => {
    const Cryptr = require('cryptr');
    const cryptr = new Cryptr(process.env.REACT_APP_PROVIDERS_SALT);
    return cryptr.encrypt(data)
}

export const keydownHandler = (event) => {
    if (event.key === "Enter" || event.keyCode === 13) {
        event.preventDefault();
        event.target.click();
    }
}

export const checkEmptyInputText = (text) => {
    return text.replace(/\s+/g, '') === '';
}

export const openUrl = (url, newWindow, targetOrigin, isStandalone) => {
    if (window.parent) {
        const data = {
            name: 'linkClick',
            value: url,
            newWindow: newWindow || false,
        };
        window.parent.postMessage(data, targetOrigin || '*');
        if (isStandalone) {
            window.location.href = url;
        }
    }
}

export const getTimeAMPMFormat = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    hours = hours < 10 ? '0' + hours : hours;
    // appending zero in the start if hours less than 10
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return hours + ':' + minutes + ' ' + ampm;
};